var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGpt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16.83333396911621,
    height: 14.5,
    viewBox: "0 0 16.83333396911621 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.3333,3.5L16.3333,5.375C16.3333,8.067499999999999,14.0296,10.25,11.1875,10.25L9.20833,10.25L9.20833,14L7.625,14L7.625,8.75L7.64004,8C7.84192,5.483,10.06254,3.5,12.7708,3.5L16.3333,3.5ZM3.66667,0.5C6.1145,0.5,8.19183,2.00375,8.92571,4.0895C7.73821,5.04575,6.95446,6.4355,6.846,8L6.04167,8C2.98108,8,0.5,5.6495,0.5,2.75L0.5,0.5L3.66667,0.5Z",
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66667,0L0,0L0,2.75Q0,5.13969,1.77924,6.82529Q3.54699,8.5,6.04167,8.5L7.12998,8.5L7.125,8.75L7.125,14.5L9.70833,14.5L9.70833,10.75L11.1875,10.75Q13.5183,10.75,15.1701,9.18516Q16.8333,7.60944,16.8333,5.375L16.8333,3L12.7708,3Q10.8903,3,9.43597,4.03326L9.39736,3.92355Q8.78612,2.1863200000000003,7.22406,1.101871Q5.63692,0,3.66667,0ZM1,1L1,2.75Q1,4.70956,2.46699,6.09934Q3.94547,7.5,6.04167,7.5L6.39594,7.5Q6.69253,5.40069,8.330210000000001,3.93897Q7.80384,2.72174,6.65378,1.92332Q5.32382,1,3.66667,1L1,1ZM9.59624,5.18113Q10.9356,4,12.7708,4L15.8333,4L15.8333,5.375Q15.8333,7.17931,14.4823,8.459209999999999Q13.1198,9.75,11.1875,9.75L8.70833,9.75L8.70833,13.5L8.125,13.5L8.125,8.75L8.13963,8.02544Q8.279910000000001,6.34197,9.59624,5.18113Z",
    fillRule: "evenodd",
    fill: "#2C2C0D",
    fillOpacity: 0.8799999952316284
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGpt3);
export default __webpack_public_path__ + "static/media/icon-gpt3.6ef355dd3067f8f74535afaded1f8e12.svg";
export { ForwardRef as ReactComponent };